import { UserSubscription } from '@core/models/entities/subscription.model';
import { User } from '@core/models/entities/user.models';

export interface ProfileState {
  user: User | null;
  subscriptions: UserSubscription[] | [];
  error: string | null;
}

export const initialState: ProfileState = {
  user: null,
  subscriptions: [],
  error: null,
};
